<template>
  <div class="page-container">
    <div id="searchArea">
      <div class="clearfix">
        <div class="fl pb10">
          <el-button type="primary" :disabled="addBtnLoading" @click="addOrUpdateHandle()">Add Campaign</el-button>
        </div>
        <div class="fr">
          <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList(1)">
            <el-form-item>
              <el-input v-model="dataForm.title" placeholder="Title" clearable class="wd250"></el-input>
            </el-form-item>
            <el-form-item>
              <el-select v-model="dataForm.status" clearable placeholder="Status" class="wd200">
                <el-option v-for="item in campaignPushStatusList" :key="item.value" :label="item.title" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-input v-model="dataForm.receiver" placeholder="Email / Client Code / Company Name" clearable class="wd300"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" type="primary" plain v-debounce @click="getDataList(1)">Search</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <div>
      <el-table
        max-height="640"
        :data="dataList"
        v-loading="dataListLoading"
        @sort-change="tableSortChange"
        :default-sort="{ prop: 'createTime', order: 'descending' }"
        style="width: 100%"
      >
        <el-table-column prop="title" align="center" label="Title" min-width="150"></el-table-column>
        <el-table-column prop="template" align="center" label="Template" min-width="150">
          <template slot-scope="scope">
            <p>{{ scope.row.template?.title || "" }}</p>
          </template>
        </el-table-column>
        <el-table-column align="center" label="Tags" min-width="200">
          <template slot-scope="scope">
            <p v-if="scope.row.tags?.length > 0">{{ scope.row.tags.map(i => i.tagName)?.join(", ") }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="sendType" align="center" label="Send Type" width="160">
          <template slot-scope="scope">
            <p>{{ marketingEmailPushTypeFormat(scope.row.sendType) }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="scheduledTime" align="center" label="Scheduled Send Time" width="180"></el-table-column>
        <el-table-column prop="status" align="center" label="Status" width="140">
          <template slot-scope="scope">
            <p>{{ campaignPushStatusFormat(scope.row.status) }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="totalCount" align="center" label="Total Sent" width="130"></el-table-column>
        <el-table-column prop="failReason" align="center" label="Send Failure Reason" min-width="300"></el-table-column>
        <el-table-column prop="sendTime" align="center" label="Send Time" width="166"></el-table-column>
        <el-table-column prop="createTime" align="center" label="Create Time" width="166" sortable="custom"></el-table-column>
        <el-table-column prop="remark" align="center" label="Remark" min-width="260"></el-table-column>
        <el-table-column align="center" width="150" fixed="right" label="Action">
          <template slot-scope="scope">
            <el-button type="text" class="fwb" @click="addOrUpdateHandle(scope.row)" v-if="scope.row.status == 'DRAFT'">Edit</el-button>
            <el-button type="text" class="fwb" @click="deleteHandle(scope.row)" v-if="scope.row.status == 'DRAFT'">Delete</el-button>
            <!-- 收件人清单 -->
            <el-button type="text" class="fwb" @click="receiveListHandle(scope.row)" v-if="['SUCCESS', 'FAILED'].includes(scope.row.status)">
              Receive List
            </el-button>
            <!-- 立即发送 -->
            <template v-if="scope.row.sendType == 1">
              <el-button type="text" class="fwb" @click="sendHandle(scope.row)" v-if="scope.row.status == 'DRAFT'">Send Now</el-button>
            </template>
            <!-- 确认定时发送 / 取消定时发送 -->
            <template v-if="scope.row.sendType == 2">
              <el-button type="text" class="fwb" @click="sendHandle(scope.row)" v-if="scope.row.status == 'DRAFT'">Confirm Schedule</el-button>
              <el-button type="text" class="fwb" @click="cancelScheduleHandle(scope.row)" v-if="scope.row.status == 'PENDING'">Cancel Schedule</el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <pagination
      :current="current"
      :pageSize="pageSize"
      :totalCount="totalCount"
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
    ></pagination>

    <!-- 弹窗, 新增 / 修改 -->
    <add-or-update ref="addOrUpdate" :tagInfoList="tagInfoList" :templateList="templateList" @refreshDataList="getDataList"></add-or-update>
    <!-- 收件人清单 -->
    <receive-list ref="receiveList"></receive-list>
  </div>
</template>

<script>
import AddOrUpdate from "./modal/AddOrUpdate";
import ReceiveList from "./modal/ReceiveList";
import Pagination from "@/components/Pagination";
import tableMixin from "@/mixins/tableMixin";
import paginationMixin from "@/mixins/paginationMixin";
import formatterMixin from "@/mixins/formatterMixin";
import { mapState } from "vuex";
export default {
  mixins: [tableMixin, paginationMixin, formatterMixin],
  components: {
    AddOrUpdate,
    ReceiveList,
    Pagination,
  },
  data() {
    return {
      dataForm: {
        title: "",
        status: "",
        receiver: "",
        "orders[0].asc": false,
        "orders[0].column": "id",
      },
      dataList: [],
      addBtnLoading: false,
      dataListLoading: false,
      tagInfoList: [],
      templateList: [],
    };
  },
  computed: {
    ...mapState("constant", ["campaignPushStatusList"]),
  },
  methods: {
    // 获取标签列表
    getTagInfoList() {
      return new Promise((resolve, reject) => {
        this.$http
          .get("/admin/clientTagInfo/getList")
          .then(res => {
            this.tagInfoList = res.data || [];
            resolve();
          })
          .catch(err => {
            reject();
          });
      });
    },
    // 获取营销邮件模版列表
    getTemplateList() {
      return new Promise((resolve, reject) => {
        this.$http
          .get("/admin/promoEmailTemplate/getList")
          .then(res => {
            this.templateList = res.data || [];
            resolve();
          })
          .catch(err => {
            reject();
          });
      });
    },
    // 获取数据分页
    async getDataList(current) {
      this.dataListLoading = true;
      if (current) {
        this.current = current;
      }
      const params = {
        current: this.current,
        size: this.pageSize,
        ...this.dataForm,
      };
      const { code, data } = await this.$http.get("/admin/promoEmailPush/paging", {
        params,
      });
      if (code === 200) {
        this.dataList = data.records;
        this.totalCount = data.total;
      } else {
        this.dataList = [];
        this.totalCount = 0;
      }
      this.dataListLoading = false;
    },
    // 新增 / 修改
    addOrUpdateHandle(row) {
      this.$refs.addOrUpdate.init(row);
    },
    // 删除
    async deleteHandle(row) {
      await this.$confirm(`Delete this campaign. Continue?`, "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      });
      const { code, msg } = await this.$http.post(`/admin/promoEmailPush/${row.id}/delete`, {});
      if (code === 200) {
        this.$message({
          message: "success",
          type: "success",
          duration: 1500,
          onClose: () => {
            // mixins
            this.singleDataDelete();
            this.getDataList();
          },
        });
      } else {
        this.$message.error(msg);
      }
    },
    // 收件人清单
    receiveListHandle(row) {
      this.$refs.receiveList.init(row);
    },
    // 立即发送 / 确认定时发送
    async sendHandle(row) {
      const tip = row.sendType == 2 ? `This campaign will be sent automatically at the scheduled time. Continue?` : `Send this campaign now. Continue?`;
      await this.$confirm(tip, "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      });
      this.$http.post(`/admin/promoEmailPush/${row.id}/submit`, {}).then(({ code, msg }) => {
        if (code === 200) {
          this.getDataList();
          this.$message.success("success");
        } else {
          this.$message.error(msg);
        }
      });
    },
    // 取消定时发送
    async cancelScheduleHandle(row) {
      await this.$confirm(`Cancel scheduled this campaign. Continue?`, "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      });
      this.$http.post(`/admin/promoEmailPush/${row.id}/cancel`, {}).then(({ code, msg }) => {
        if (code === 200) {
          this.getDataList();
          this.$message.success("success");
        } else {
          this.$message.error(msg);
        }
      });
    },
  },
  async activated() {
    try {
      this.addBtnLoading = true;
      this.dataListLoading = true;
      await this.getTagInfoList();
      await this.getTemplateList();
    } catch (error) {
    } finally {
      this.addBtnLoading = false;
      this.getDataList();
    }
  },
};
</script>

<style lang="scss" scoped></style>
